import React from 'react';

// Components
import DatePaginationButtonLeft from './components/DatePaginationButtonLeft';
import DatePaginationButtonRight from './components/DatePaginationButtonRight';
import DatePaginationFormattedDate from './components/DatePaginationFormattedDate';

interface Props {
    numberOfDays?: number;
}

export default class DatePagination extends React.PureComponent<Props> {
    render() {
        const { numberOfDays } = this.props;
        return (
            <div
                style={{
                    position: 'relative',
                    top: 2
                }}
            >
                <DatePaginationButtonLeft numberOfDays={numberOfDays} />
                <DatePaginationButtonRight numberOfDays={numberOfDays} />
                <DatePaginationFormattedDate numberOfDays={numberOfDays} />
            </div>
        );
    }
}
